import AutocompleteBase, {
  AutocompleteBaseProps,
} from 'components/forms/fields/autocomplete-field/autocomplete-base/autocomplete-base.component';
import { useSearchParam } from 'components/search/search.hooks';
import { ChangeEvent } from 'react';
import { Option } from 'util/multi-select';
import { useFocusFilter } from '../search-filters.hooks';

type SingleSelectFilterProps = {
  searchParamName: string;
  'data-testid'?: string;
} & Partial<AutocompleteBaseProps>;

export const SingleSelectFilter = ({
  searchParamName,
  ...rest
}: SingleSelectFilterProps) => {
  const {
    value,
    setValue,
    options,
    searchParam: {
      filter: { label, componentProps },
      defaultValue,
    },
    setFocus,
  } = useSearchParam<string>(searchParamName);
  const typedComponentProps =
    (componentProps as Partial<AutocompleteBaseProps>) ?? {};
  const { ref, open, setOpen, readOnly } = useFocusFilter(setFocus);

  const onChange = (_e: ChangeEvent<HTMLSelectElement>, value: Option) =>
    setValue(value?.id || defaultValue);

  return (
    <AutocompleteBase
      label={label}
      data-testid="SingleSelectFilter"
      options={options}
      value={value}
      onChange={onChange}
      isOptionEqualToValue={(option, value) => option.id === value}
      limitTags={1}
      ref={ref}
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      inputProps={{ readOnly }}
      {...typedComponentProps}
      {...rest}
    />
  );
};

export default SingleSelectFilter;
